export default "__VITE_ASSET__BNghLC4S__"